module.exports = __webpack_public_path__ + "img/facebook.795c84ad.svg";